import { useState } from "react";
import logoImg from "../images/skylogo.png";
import facebook from "../images/facebook.png";
import instagram from "../images/Instagram.webp";
import linkedin from "../images/linkedin.png";
import x from "../images/x.png";
import call from "../images/call.png";
import whatsapp from "../images/whatsapp.png";
import location from "../images/loc.png";
import mail from "../images/mail.webp";


function Footer() {
  const [email, setEmail] = useState("");

  const handleSubscribe = () => {
    if (!email) {
      alert("Please enter an email");
      return;
    }
    alert(`Subscribed with: ${email}`);
    setEmail("");
  };

  return (
    <footer id="contact" className="bg-light pt-5 pb-4 mt-5">
      <div className="container">
        <div className="row gy-4">
<div className="col-12 col-md-3 text-center">
  <img
    src={logoImg}
    alt="SkyIndoors Logo"
    className="rounded-circle mb-0" 
    style={{ height: "160px", width: "160px" }}
  />

  <div className="bg-light pt-2 pb-3 mt-1 d-flex justify-content-center align-items-center gap-2">
    <input
      type="email"
      className="form-control"
      placeholder="Enter your email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      style={{ width: "150px" }}
    />

    <button className="btn btn-success" onClick={handleSubscribe}>
      Subscribe
    </button>
  </div>
</div>


          {/* Follow Us */}
          <div className="col-12 col-md-3">
            <h4 className="fw-bold mb-3">Follow Us</h4>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a className="d-flex align-items-center gap-2 text-decoration-none text-secondary"
                   href="https://www.facebook.com/share/17gSdqkEiv/" target="_blank" rel="noreferrer">
                  <img src={facebook} alt="Facebook" width="30" />
                  <span>Sky Indoors</span>
                </a>
              </li>
              <li className="mb-2">
                <a className="d-flex align-items-center gap-2 text-decoration-none text-secondary"
                   href="https://www.instagram.com/" target="_blank" rel="noreferrer">
                  <img src={instagram} alt="Instagram" width="30" />
                  <span>@skyindoors</span>
                </a>
              </li>
              <li className="mb-2">
                <a className="d-flex align-items-center gap-2 text-decoration-none text-secondary"
                   href="https://www.linkedin.com/" target="_blank" rel="noreferrer">
                  <img src={linkedin} alt="LinkedIn" width="30" />
                  <span>SkyIndoors</span>
                </a>
              </li>
              <li>
                <a className="d-flex align-items-center gap-2 text-decoration-none text-secondary"
                   href="https://x.com/SkyIndoors" target="_blank" rel="noreferrer">
                  <img src={x} alt="X" width="30" />
                  <span>@SkyIndoors</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Us */}
          <div className="col-12 col-md-3">
            <h4 className="fw-bold mb-3">Contact Us</h4>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a className="d-flex align-items-center gap-2 text-decoration-none text-secondary"
                   href="tel:7794946360">
                  <img src={call} alt="Call" width="30" />
                  <span>+91 77949 46360</span>
                </a>
              </li>
              <li className="mb-2">
                <a className="d-flex align-items-center gap-2 text-decoration-none text-secondary"
                   href="https://wa.me/message/2IFIFHKHEM4ZK1" target="_blank" rel="noreferrer">
                  <img src={whatsapp} alt="WhatsApp" width="30" />
                  <span>+91 86865 82926</span>
                </a>
              </li>
              <li className="mb-2">
                <a className="d-flex align-items-center gap-2 text-decoration-none text-secondary"
                   href="mailto:skyindoors1@gmail.com">
                  <img src={mail} alt="Email" width="30" />
                  <span>help@skyindoors.com</span>
                </a>
              </li>
              <li>
                <a className="d-flex align-items-start gap-2 text-decoration-none text-secondary"
                   href="https://maps.app.goo.gl/BbUrWLEoKcd7WHyp6" target="_blank" rel="noreferrer">
                  <img src={location} alt="Location" width="30" />
                  <span>GuddiMalkapur, Hyderabad, TG - 500028</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="col-12 col-md-3">
            <h4 className="fw-bold mb-3">Our Services</h4>
            <ul className="list-unstyled">
              <li><a className="text-decoration-none text-secondary" href="/windows">Windows</a></li>
              <li><a className="text-decoration-none text-secondary" href="/doors">Doors</a></li>
              <li><a className="text-decoration-none text-secondary" href="/wardrobe">Wardrobe</a></li>
              <li><a className="text-decoration-none text-secondary" href="/cabnet">Kitchen Cabinets</a></li>
              <li><a className="text-decoration-none text-secondary" href="/elevation">Elevation</a></li>
              <li><a className="text-decoration-none text-secondary" href="/partition">Partitions</a></li>
              <li><a className="text-decoration-none text-secondary" href="/">Glass & More</a></li>
            </ul>
          </div>

        </div>

        {/* Bottom Line */}
        <hr className="my-4" />
        <p className="text-center text-muted mb-0">
          © Copyright 2025 SkyIndoors.All Rights Reserved — Designed By @rasheedsaquib
        </p>
      </div>
    </footer>
  );
}

export default Footer;
